enum UI {
    ChangeVerticalTabs = 4700,
    SelectActivePatientFile,
    CloseActivePatientFile,
    TogglePatientHeaderDropdownMenu,
    TogglePatientMergeRequestPopup,
    ToggleCancelPatientMergeRequestPopup
}

enum Profile {
    ChangeProfileTabs = 4800,
    AddMemoClick,
    CancelMemoClick,
    CancelEditMemoClick,
    SaveMemoClick,
    ModifyMemoClick,
    DeleteMemoClick,
    EditMemoClick,
    DeactivatePatientClick,
    DeactivatePatientCancelClick,
    DeactivatePatientSaveClick,
    DeactivatePatientNoteChange,
    DeactivatePatientReasonChange,
    ImageUpload_Open,
    ImageUpload_Cancel,
    ImageUpload_OpenSelectFile,
    ImageUpload_Completed,
    ImageUpload_FileSelected,
    MarkTestPatientClick,
    MarkTestPatientCancelClick,
    MarkTestPatientSaveClick,
    NAMLabelClick,
    DOBLabelClick,
    PhoneLabelClick,
    EmailLabelClick,
    AddressLabelClick,
    PatientFirstNameLabelClick,
    PreferredIntervenorOnFileClick,
    EnrollmentStatusLabelClick,
    ClearBannerExpressEdit,
    CloseDropDown,
    ShowAddNewExternalMessagePopup,
    ShowRedActiveNoteTab,

    PrintSummary,
    PrintC1Label,
    PrintC2Label,
    PrintC3Label,
    PrintRLabel,
    PrintALabel,
    PrintBillingLabel,
    PrintTXLabel,

    Demographics_EditClick,
    Demographics_CancelClick,
    Demographics_SaveClick,
    Demographics_SelectPrefix,
    Demographics_FirstNameChange,
    Demographics_LastNameChange,
    Demographics_MiddleNameChange,
    Demographics_PreferredNameChange,
    Demographics_SelectSuffix,
    Demographics_SelectPreferredPronouns,
    Demographics_SpecifiedPreferredPronounsChange,
    Demographics_MothersFirstNameChange,
    Demographics_MothersLastNameChange,
    Demographics_FathersFirstNameChange,
    Demographics_FathersLastNameChange,
    Demographics_SocialInsuranceChange,
    Demographics_GenderSelect,
    Demographics_GenderIdentityChange,
    Demographics_ReligionChange,
    Demographics_DateOfBirthChange,
    Demographics_LegalStatusSelect,
    Demographics_OfficialLanguageSelect,
    Demographics_SpokenLanguageSelect,
    Demographics_PatientStatusSelect,
    Demographics_PatientStatusDateChange,
    Demographics_ProfessionChange,
    Demographics_EmployerChange,
    Demographics_NotesChange,
    Demographics_Binding,
    Demographics_EthnicitySelect,
    Demographics_EthnicityClear,

    Identifiers_CancelClick,
    Identifiers_SaveClick,
    Identifiers_EditClick,
    Identifiers_NAMSelectCountry,
    Identifiers_NAMSelectProvince,
    Identifiers_NAMNumberChange,
    Identifiers_NAMVersionChange,
    Identifiers_NAMExpirationDateChange,
    Identifiers_Identifier01Change,
    Identifiers_Identifier02Change,
    Identifiers_Identifier03Change,
    Identifiers_OtherIdOrganizationChange,
    Identifiers_OtherIdNumberChange,
    Identifiers_AddHealthCard,
    Identifiers_AddOtherId,
    Identifiers_RemoveHealthCard,
    Identifiers_RemoveOtherId,

    Contacts_CancelClick,
    Contacts_SaveClick,
    Contacts_EditClick,
    Contacts_PhoneCountrySelect,
    Contacts_PhoneTypeSelect,
    Contacts_PhoneNumberChange,
    Contacts_PhoneExtChange,
    Contacts_PhoneNotesChange,
    Contacts_PhoneIsPreferredCheck,
    Contacts_PhoneDefaultNotificationChange,
    Contacts_AddressTypeSelect,
    Contacts_AddressChange,
    Contacts_AddressCityChange,
    Contacts_AddressCountrySelect,
    Contacts_AddressCountryRegionSelect,
    Contacts_AddressZipCodeChange,
    Contacts_AddressIsPreferredCheck,
    Contacts_EmailTypeSelect,
    Contacts_EmailAddressChange,
    Contacts_EmailCanContactChange,
    Contacts_DoNotEmailChange,
    Contacts_EmailDefaultNotificationChange,
    Contacts_RepAddressTypeSelect,
    Contacts_RepAddressChange,
    Contacts_RepAddressCityChange,
    Contacts_RepAddressCountrySelect,
    Contacts_RepAddressCountryRegionSelect,
    Contacts_RepAddressZipCodeChange,
    Contacts_AddPhone,
    Contacts_RemovePhone,
    Contacts_AddAddress,
    Contacts_RemoveAddress,
    Contacts_AddRepAddress,
    Contacts_RemoveRepAddress,
    Contacts_AddEmail,
    Contacts_RemoveEmail,
    Contacts_EditEmailsClick,
    Contacts_CloseEmailsClick,
    Contacts_UpdateNotificationsFromAppointmentSave,

    Clinicians_EditClick,
    Clinicians_CancelClick,
    Clinicians_SaveClick,
    Clinicians_SelectDoctor,
    Clinicians_SelectDoctorEmployee,
    Clinicians_SelectSpeciality,
    Clinicians_SetIntervenorEditMode,
    Clinicians_AddIntervenorOpen,
    Clinicians_AddIntervenorClose,
    Clinicians_AddIntervenorSave,
    Clinicians_DeleteIntervenor,
    Clinicians_ClearIntervenorSpeciality,
    Clinicians_IsPrimaryChange,
    Clinicians_OnNoteChange,
    Clinicians_LoadHealthCareProviders,
    Clinicians_UpdateHealthCareProvider,
    Clinicians_EditConsultant,
    Clinicians_SaveConsultant,
    Clinicians_ContactDirectory_ExternalProvider_Edit,
    Clinicians_EditPatientFileAllowlist,

    OtherInfo_EditClick,
    OtherInfo_CancelClick,
    OtherInfo_SaveClick,
    OtherInfo_SearchStringChange,
    OtherInfo_LoadPreferredDirectoryPharmacy,
    OtherInfo_PharmacySelect,
    OtherInfo_PharmacistsChange,
    OtherInfo_PharmacyPhoneChange,
    OtherInfo_PharmacyFaxChange,
    OtherInfo_PharmacyBannerChange,
    OtherInfo_PharmacyNameChange,
    OtherInfo_PharmacyAddressChange,
    OtherInfo_InsuranceCompanyNameChange,
    OtherInfo_InsurancePolicyNoChange,
    OtherInfo_InsuranceRemove,
    OtherInfo_PharmacyRemove,
    OtherInfo_AddConsentPopup,
    OtherInfo_CloseConsentPopup,
    OtherInfo_SelectConsentProgram,
    OtherInfo_OnDocGivenClick,
    OtherInfo_OnHasConsentClick,
    OtherInfo_OnHasRefusedClick,
    OtherInfo_OnRemoveConsentClick,
    OtherInfo_AddConsentProgramClick,
    OtherInfo_ChangeDocGivenDate,
    OtherInfo_ChangeConsentRefuseDate,
    OtherInfo_ModifyConsentClick,
    OtherInfo_UpdateConsentProgram,
    OtherInfo_TodayClickSelectedConsent,
    OtherInfo_TodayClickDocGiven,
    OtherInfo_OnDidntRespondClick,
    OtherInfo_OnHasRevokedClick,
    OtherInfo_ChangeConsentRevokeDate,
    OtherInfo_TodayClickConsentRevoked,
    OtherInfo_LoadConsentProgramHistory,
    OtherInfo_AddConsentProgramDialog,
    OtherInfo_CloseConsentProgramDialog,

    Relationships_EditClick,
    Relationships_CancelClick,
    Relationships_SaveClick,
    Relationships_RemoveClick,
    Relationships_RelationshipBinding,
    Relationships_RelationshipLinkedContactMutation,

    Enrollment_EnrollPatientClick,
    Enrollment_EnrollPatientClose,
    Enrollment_EnrollPatientTransmit,
    Enrollment_EnrollPatientTransmitAndPrint,
    Enrollment_TerminateEnrollmentClick,
    Enrollment_TerminateEnrollmentCancel,
    Enrollment_TerminateEnrollmentChange,
    Enrollment_TerminateEnrollmentTransmitClick,
    Enrollment_TerminateReasonChange,

    Enrollment_CloseRAMQErrorDialog,
    Enrollment_RAMQErrorDialogGoEdit,
    Enrollment_CloseRAMQQuestionDialog,
    Enrollment_RAMQQuestionDialogYes,
    Enrollment_ModifyCancel,
    Enrollment_ModifyEnrollmentDateClick,
    Enrollment_ModifyResidentEditClick,
    Enrollment_ModifyResidentDeleteClick,
    Enrollment_ModifyRepEditClick,
    Enrollment_ModifyRepDeleteClick,
    Enrollment_ModifyLieuSuiviClick,
    Enrollment_ModifyCaracteristiqueClick,

    Enrollment_TransmitEnrollmentDateClick,
    Enrollment_TransmitEditResidentClick,
    Enrollment_TransmitDeleteResidentClick,
    Enrollment_TransmitEditRepClick,
    Enrollment_TransmitDeleteRepClick,
    Enrollment_TransmitLieuSuiviClick,
    Enrollment_TransmitCaracteristiqueClick,

    Enrollment_DispensateurChange,
    Enrollment_NoGmfChange,
    Enrollment_DatePriseEffetChange,
    Enrollment_ResidentChange,
    Enrollment_RepFirstNameChange,
    Enrollment_RepLastNameChange,
    Enrollment_RepNAMChange,
    Enrollment_RepTypeChange,
    Enrollment_LieuSuiviChange,
    Enrollment_LieuSuiviDateChange,
    Enrollment_CaracteristiqueSante1Change,
    Enrollment_CaracteristiqueSante2Change,
    Enrollment_CaracteristiqueSante3Change,
    Enrollment_CaracteristiqueSanteDate1Change,
    Enrollment_CaracteristiqueSanteDate2Change,
    Enrollment_CaracteristiqueSanteDate3Change,

    Enrollment_GenerateEmptyFormClick,
    Enrollment_GenerateRAMQFormClick,
    DeleteProfilePic,
    Enrollment_SetOntarioEnrollmentPatientBanner,

    PatientLastNameLabelClick,
    PatientGenderLabelClick,

    PopulationBasedFunding_SetPatientData,
    PatientBanner_ShowPopulationBasedFundingTab,
    PopulationBasedFunding_SignalIconUpdate,

    Relationships_AddRelation,

    Demographics_UpdateMandatoryFields,
    OtherInfo_Redirect,
    UpdatePatientMergeStatus,
    UpdateCancelPatientMergeStatus
}

enum Appointment {
    ShowServiceFinder = 5300,
    HideServiceFinder,
    OnOkClick,
    ChangeTabToStaff,
    ChangeTabToService,
    ClinicianSearchChanged,
    OnClinicianTab_ClinicianSelected,
    OnClick_CliniciansService,
    OnClick_EmployeeTabAllServices,
    OnClick_EmployeeTabOtherService,
    OnClick_Services,
    OnClick_ServicesClinician,
    ServiceSearchChanged,
    OnClick_ServiceTabAllEmployee,
    Remove_SearchCriteria,
    OpenPredefinedAppointmentTimeSlot,
    CancelSavePredefinedAppointment,
    ResetClick,
    Reload,
    Next,
    Previous,
    MondayClick,
    TuesdayClick,
    WednesdayClick,
    ThursdayClick,
    FridayClick,
    WeekdayClick,
    WeekendClick,
    AsapClick,
    AddWeekClick,
    AddMonthClick,
    AMClick,
    PMClick,
    OnModifyClick,
    OnOkEditClick,
    OnCancelModifiedAppoinment,
    OnChangeAppointmentSubject,
    OnSelectSubjectService,
    OnOkModifiedAppointment,
    OnDurationModifiedAppointmentChange,
    onAppointmentMount,
    OnServiceForEmployeeItemClick,
    OnServiceForServiceItemClick,
    on_ClinicianTab_AnyService_Click,
    OnServiceDurationEdit,
    OnAnyServiceDurationEdit,
    OnSearchTabSelected,
    IgnorePublishingRulesClick
}

enum History {
    ChangeHistoryTab = 5400,

    Message_LoadPatientMessage,
    Message_ShowSelectedMessage,
    Message_SearchText,
    Message_CriteriaClick,
    Message_FromDateChanged,
    Message_ToDateChanged,
    Message_ToggleListDisplayMode,

    Task_SearchText,
    Task_LoadPatientTask,
    Task_ShowSelectedTask,
    Task_FromDateChanged,
    Task_StatusChanged,
    Task_ShowSelectedTaskFromRedirect,

    Task_ToDateChanged,
    Task_CriteriaClick,
    Task_ToggleListDisplayMode,

    Communications_AddNewCommunication,
    Communications_LoadPatientCommunication,
    Communications_CancelAddNewCommunications,
    Communications_OkAddNewCommunications,
    Communications_OkAddNewCallCommunications,
    Communications_EditCallCommunications,
    Communications_DeleteCommunications,
    Communications_OkEditCallCommunications,
    Communications_StatusChange,
    Communications_NoteTextChange,
    Communications_ClinicianAdded,
    Communications_ClinicianCleared,
    Communications_CallDateChange,
    Communications_CallTimeStartChange,
    Communications_CallTimeEndChange,
    Communications_CallReasonChange,

    Recall_SearchText,
    Recall_LoadPatientRecall,
    Recall_ShowSelectedRecall,
    Recall_FromDateChanged,
    Recall_ToDateChanged,
    Recall_CriteriaClick,
    Recall_ShowCompleted,
    Recall_ShowCurrent,
    Recall_ChangeRecallShown,
    Recall_MarkRecallAsCompleted,
    Recall_AddNewEntry,
    Recall_CancelNewEntry,
    Recall_LoadSelectedRecall,
    Recall_ShowOnlyNotCompleted,

    Appointment_SearchText,
    Appointment_CriteriaClick,
    Appointment_ChangeAppointmentShown,
    Appointment_LoadPatientAppointment,
    Appointment_ShowSelectedAppointment,
    Appointment_FromDateChanged,
    Appointment_ToDateChanged,
    Appointment_OnPrintLabelClick,
    Appointment_OnPrintHistoryClick,
    Appointment_ModifySelectedAppointment,
    Appointment_CancelModifyAppointment,
    Appointment_SaveModifyAppointment,
    Appointment_StateConfirmCheck,
    Appointment_ShowOnlyCurrent,
    Appointment_OnSiteChange,
    Appointment_ConfirmGroupStateEdit,
    Appointment_ShowQuestionnaire,
    Appointment_OnQuestionnaireSubmitted,
    Appointment_PrintCertificate,

    PrivateBill_SearchText,
    PrivateBill_CriteriaClick,
    PrivateBill_FromDateChanged,
    PrivateBill_ToDateChanged,
    PrivateBill_LoadPatientPrivateBill,
    PrivateBill_ShowSelectedPrivateBill,
    PrivateBill_InvalidateBill,
    PrivateBill_CloseInvalidPopup,
    PrivateBill_SaveInvalidation,
    PrivateBill_NoteInvalidationChange,
    PrivateBill_DateOfVisit_Set,
    PrivateBill_CreateNewBill,
    PrivateBill_OnTodayClick,
    PrivateBill_SiteChange,
    PrivateBill_AddNewEmptyService,
    PrivateBill_RemoveService,
    PrivateBill_ChangeHasGST,
    PrivateBill_ChangeHasQST,
    PrivateBill_ChangeHasHST,
    PrivateBill_ChangeHasGenericTax,
    PrivateBill_OnCancelClick,
    PrivateBill_CancelNewBill,
    PrivateBill_CloseCancelPopup,
    PrivateBill_SelectBillableService,
    PrivateBill_OnQuantityChange,
    PrivateBill_OnPriceChange,
    PrivateBill_ClearSelection,
    PrivateBill_OnDiscountChange,
    PrivateBill_ChangeDiscountType,
    PrivateBill_Print,
    PrivateBill_OnSaveClick,
    PrivateBill_OnSaveAndPrintClick,
    PrivateBill_OnSelectedPaymentChange,
    PrivateBill_SelectClinician,
    PrivateBill_RemoveSelectedClinician,
    PrivateBill_OnNotesChange,
    PrivateBill_OnCostCenterChange,
    PrivateBill_PortalStatusClicked,
    PrivateBill_PortalStatusCancel,
    PrivateBill_PortalStatusRevoke,
    PrivateBill_PortalStatusClicked_FromEdit,
    PrivateBill_PortalStatusSaveFromEdit,
    PrivateBill_PortalStatusSaveAndPrintFromEdit,
    PrivateBill_DeleteSelectedBill,

    PrivateBill_CloseSelectedBill,
    PrivateBill_CloseSelectedBillThenPrint,

    PrivateBill_SendBillToPortal,
    PrivateBill_SendBillToPortalThenPrint,

    PrivateBill_OnRecipientDetailsChange,
    PrivateBill_Billing_OnBilledToChange,
    PrivateBill_Billing_SaveAndSyncNewBillToPortal,
    PrivateBill_CloseSendToPortalPopup,

    PrivateBill_OnModifyOrDuplicateClick,
    PrivateBill_LockProvider,
    PrivateBill_OpenMarkBillAsPaidPopup,
    PrivateBill_CloseMarkBillAsPaidPopup,
    PrivateBill_UpdateBillAndCloseMarkBillAsPaidPopup,
    LoadDummyServices,

    OnPortalInvoiceMessageChecked,
    OnPortalInvoiceMessageToBeRevoke,

    Communications_onPortalStatusClicked,
    Communications_onCloseSendToPortalPopupClick,
    Communications_onSharedItemCheck,
    Communications_onSendToPortalClick,
    Communications_PortalStatusRevoke,
    AttachedCommunicationsClose,
    OnPortalCommunicationMessageChecked,
    TaskRedirectFromEncounterOrLabs,
    MessageRedirectFromEncounter,
    RecallRedirectFromEncounter,
    PrivateBill_OnFaxClick,
    PrivateBill_OnPrintClick,
    PortalCommunicationsSetCurrentThread
}

enum MedicalSummary {
    TabMounted = 5600,
    TabUnmounted,
    PrintNotes,
    SwitchToDetails,
    EncounterSearchTermChanged,
    EncounterClick,
    EncounterSearchCriteriaDisplayToggle,
    EncounterDateFromChanged,
    EncounterDateToChanged,
    EncounterMyNotesFilterTermChanged,
    EncounterUnapprovedNotesFilterTermChanged,
    EncounterClinicVisitNotesFilterTermChanged,
    ToggleDisplayOnlyUnsigned,
    ReorderMedicalItemAlertsSpecialNeeds,
    ReorderMedicalItemActiveMedication,
    ReorderMedicalItemSocialHabits,
    ReorderMedicalItemImmunizations,
    ReorderMedicalItemProblems,
    ToggleAlert,
    RemoveAlert,
    CloseAlertPopup,
    ToggleVisibilityOfSummaryAlertForPrinting,

    Details_BackToSummary,

    NewNote,
    NewNoteWarningStartNewNote,
    NewNoteWarningContinueNote,
    NewNoteWarningCancel,
    NewNoteNoSpecialityWarningOK,

    CloseMedicalItemWarningPopup,

    SaveObstetricalSummary,
    UpsertVitalSign,

    CancelMedicalItemActionFromOutsideNote
}

enum MedicalNote {
    TabMounted = 5800,
    ToggleOpenSection,
    ShowNotePopup,
    CloseNotePopup,
    AddEncounterNote,
    NewPrescription,
    ShowRISRequestPopup,
    CloseRequestEditPopup,
    CloseRISRequestPopup,

    ShowPrivateBillPopup,
    ShowCreatedPrivateBillEditPopup,
    ShowPrivateBillEditPopup,
    ShowReusingBillPopup,
    CloseReusingBillPopup,
    ShowReusingPrivateBillCriteria,
    ReusingPrivateBillFromDateChange,
    ReusingPrivateBillToDateChange,
    ReusingPrivateBillSearchText,
    SelectReusingPrivateBillClick,
    ReusingContinueClick,
    ClosePrivateBillPopup,
    ClosePrivateBillEditPopup,
    OnCloseBill,
    ModifyNote,
    SignoffNote,
    CancelEditNote,
    SaveEditNote,
    SwitchToDetails,
    CompleteMedicalNoteLinkedAppointment,

    Edit_RemoveClickableTextVisibility,
    Edit_ShowClickableTextVisibility,
    Edit_ReasonTextChanged,
    Edit_PresentIllnessHistoryTextChanged,
    Edit_ExamTextChanged,
    Edit_LaboratoryTextChanged,
    Edit_ImagingTextChanged,
    Edit_OtherNotesTextChanged,
    Edit_FollowupPlanChanged,
    Edit_NewMedicalHistoryItem,
    Edit_NewMedicalReactionItem,
    Edit_NewRiskFactorItem,
    Edit_NewAlertSpecialNeedItem,
    Edit_NewFamilyHistoryItem,
    Edit_NewImmunizationItem,
    Edit_NewVitalSignItem,
    Edit_NewMedicationItem,
    Edit_NewMedicationAssessment,
    Edit_NewActiveMedication,
    Edit_NewScreeningTestItem,

    ConcurrentWarningPopup_NewNote,
    ConcurrentWarningPopup_ViewCurrent,
    AlreadySignedOffWarningPopup_Ok,
    AutoSaveAlreadySignedOffWarningPopup_Ok,
    PrivateBillWarning_Cancel,
    PrivateBillWarning_Save,
    PrivateBillWarning_SaveAndPrint,

    LabRequestPopup_ToggleIsInvalid,

    OpenConsultationRequestSignPopup_ForFax,
    GenerateConsultationRequestPdf,
    ConsultationRequest_SendFax,

    CloseConsultationRequest_ForFax,
    ConsultationRequestPopup_ToggleIsInvalid,

    ConsultationRequestPopup_OnSaveSucces,
    LabRequestPopup_OnSaveSucces,

    ConsultationDetailsPopupShow,
    ConsultationDetailsPopupClose,
    ConsultationDetailsPopupModify,

    HandNoteReady,
    DeleteHandNote,

    ClosePinPopup,
    SignNote,
    PrintNote,
    PrintSignedNote,
    PrintCharts,

    CreateRadPdfForm,
    CreatingAPSSForm,
    EditRadPdfForm,
    ViewRadPdfForm,
    GenerateToken,
    OpenRadPdfForm,
    OpenContextMenuPdf,
    CloseContextMenuPdf,
    toggleFormPersistance,
    DeletePdfForm,
    ContinueRadPdfForm,
    DuplicateRadPdfForm,
    LoadVitalsForGraphs,
    ExpandLeftMenu,
    CollapseLeftMenu,
    SaveScrollPosition,

    Billing_Save,
    Billing_Print,
    Billing_Invalid,
    Billing_LoadDummyServices,
    Billing_SiteChange,
    Billing_OnTodayClick,
    Billing_DateOfVisit_Set,
    Billing_AddNewEmptyService,
    Billing_OnCostCenterChange,
    Billing_OnSeletedPaymentChange,
    Billing_RemoveSelectedClinicianChange,
    Billing_OnDiscountChange,
    Billing_ChangeDiscountType,
    Billing_SelectClinician,
    Billing_ClearSelection,
    Billing_SelectBillableService,
    Billing_OnPriceChange,
    Billing_OnQuantityChange,
    Billing_ChangeHasQST,
    Billing_ChangeHasGST,
    Billing_ChangeHasHST,
    Billing_ChangeHasGenericTax,
    Billing_RemoveService,
    Billing_NotesChange,
    Billing_CloseInvalidate,
    Billing_InvalidateSave,
    Billing_LockProvider,
    Billing_InvalidateChange,
    Billing_Invalidate,
    Billing_InvalidNoteChange,
    Billing_SaveInvalidation,
    Billing_OnRecipientDetailsChange,

    SendToDSQ,

    ReopenPendingPrescription,

    CloseApprovalSupervisorPopup,

    OpenSupervisorSelectionPopup,

    LoadApssFormInfo,
    GenerateLabRequestPdf,
    GenerateFormPdf,
    LabRequest_OpenRequestFaxSearchLabPopup,

    LabRequest_CloseFaxResponsePopup,
    LabRequest_SendFax,
    CloseLabRequestSignPopup_ForFax,
    OpenLabrequestSignPopup_ForFax,

    ShowUnapproveNoteWarningPopup,
    UnapproveNoteOK,
    UnapproveNoteCancel,
    ShowDeleteNoteWarningPopup,
    DeleteNoteCancel,
    DeleteNoteOK,
    CloseDeletedEncounterWarningPopup,
    LoadAttachedCommunications,
    ShowAttachedCommunicationsList,
    Request_PortalClick,
    Request_ClosePortalPopup,
    Request_SendToPortal,
    Request_OnPortalRequestMessageChecked,
    Request_PortalStatusRevoke,
    MedicalNoteForm_PortalClick,
    MedicalNoteForm_ClosePortalPopup,
    MedicalNoteForm_SendToPortal,
    MedicalNoteForm_OnPortalFormMessageChecked,
    MedicalNoteForm_PortalStatusRevoke,
    MedicalNoteForm_FilePreviewChanged,
    MedicalNoteForm_SetFormToRevoke,
    RefreshPortalFormStatus,
    UpdateCurrentEncounterExtensionFormsCount,
    UpdateSecondScreenExtensionFormsCount,
    UpdateImmunizationMedicalItem,
    UpdateImmunizationMedicalItemsAfterRvqSaveAndSync,
    SubmitImmunizationToRvq,
    SelectMedicalImmunizationFromRvq,
    ExternalBilling_ReloadClaims,
    NewObstetricalFile,
    ObstetricalFileContribution,
    UpdateObstetricalFileFormDisplay,
    ShowDeleteObstetricalFileWarningPopup,
    ConfirmDeleteObtetricalFile,
    UpdateObstetricalFileForm,
    ObstetricalFile_PortalClick,
    WorkSafeBc_PortalClick,
    WorkSafeBc_HandleSaveForm,
    WorkSafeBc_UpdateForms,
    ExternalBilling_IncrementPatientBillingHistoryVersion,
    Billing_OnBilledToChange,
    PrivateBill_SaveAndFax,
    PrivateBill_SaveAndPrint,
    UpdateUserSettings,
    UpdateUserSettingsExportableFilePopup,
    UpdateUserSettingsExamRequest,
    UpdateUserSettingsConsultationRequest,
    EnableHandWrittenNotesCache,
    LoadSentFaxes,
    UpdateProgressNote,
    SaveNoteActionButtonLog
}

enum MedicationGrid {
    SettingsToggle = 6100,
    SettingsCancel,
    SettingsOk,
    ColumnsSettingOpen,
    ColumnsSettingClose,
    SearchTextChanged,
    SearchDateFromChanged,
    SearchDateToChanged,
    SearchStatusChanged,
    SearchOriginChanged,
    RefreshMedications,
    SearchDetailsChange,
    UpdatePatientComplianceValue,
    InsertMedicationNote,
    LoadMedicationNotes
}

enum PrescriptionTab {
    MedicationSelected = 6200,
    FavoriteMedicationSelected,
    RemoveMedication,
    SetMedicationModelDurationMode,
    AddDosage,
    DeleteDosage,
    ComboBoxChange,
    TextBoxChange,
    CheckBoxChange,
    Prescribe,
    CancelPrescribeAction,
    ReorderMedicationDragAndDrop,
    ToggleEditPreviewMedicationModel,
    LeftPaneActiveMed_CheckBoxChange,
    LeftPaneActiveMed_Renew,
    LeftPaneActiveMed_Adjust,
    LeftPaneActiveMed_RenewAll,
    NewEmptyRx,
    AdjustMedicationPopup_Cancel,
    AdjustMedicationPopup_Continue,
    MedicationDetails_GetVigilanceMonographie,
    GetVigilanceAnalysis,
    ToggleAddAsFavorite,
    ToggleSelectedMedicationList,
    DSQMedsLoading,
    DSQMedsLoaded,
    ExternalSearchMedicationTextChange,
    CloseActiveMedConflicsPopup,
    UpdateAllRenewalsNumberChange,
    SaveGeneralInstructions,
    SaveIsHeaderExpanded,
    StartDateChange
}

enum Fax {
    SendPrescriptionFax = 6300,
    UpdatePreferredPharmacy,
    GeneratePrescriptionPDF,
    SendConsultationRequestFax,
    GenerateConsultationRequestPDF,
    SendMedicalNoteFax,
    GenerateMedicalNotePDF,
    GenerateLabRequestPDF,
    SendLabRequestFax

}

enum MedicalItems {
    LoadEMRTemplateComments = 6400,
    SearchTermChanged,
    SelectEMRTemplate,
    ToggleVisibility,
    ToggleItemCollapse,
    ToggleAddComment,
    CancelAddComment,
    SaveAddComment,
    ToggleInvalid,
    SaveValidationNote,
    RemoveMedicalItem,
    ConfirmRemoveMedicalItem,
    CancelRemoveMedicalItem,
    RemoveAlert,
    AlertOK,
    Modify,
    Save,
    SavePlus,
    Cancel,
    ReturnToNote,
    ReturnToSummary,
    OpenRiskFactorDetails,
    CloseRiskFactorDetails,
    NewEntry,
    SetExistingScreeningItemForNewEntry,
    UpdateFollowupStatus,
    InsertMedicalRequestComment,
    UpdateScreeningsModelAfterPrintingRequest,
    SaveValidationNoteForImmunization,
    TogglePharmaNetLoginComponent,
    ToggleAsFavorite,
    ReturnToPatientResults,
    SaveRiskFactors,
    SaveImmunizations,
    ToggleFavoriteMedicalItem
}

enum MedicationTab {
    UpdateMedicationPopup_Open = 6500,
    UpdateMedicationPopup_Close,
    UpdateMedicationPopup_PreSave,
    UpdateMedicationPopup_Save,
    SearchPrescriptionTextBoxChange,
    onPrescriptionMouseEnter,
    VigilanceAnalysis
}

enum Graphs {
    ToggleAllVitalsCheck = 6600,
    ToggleAllCurvesCheck,
    VitalItemCheck,
    CurveItemCheck,
    FilterStartDateChange,
    FilterEndDateChange,
    SetUnitSystem,
    SetVersionChart,
    SetChartUIParam
}

enum MedfarBilling {
    CreateNewBill = 6700,
    ClosePopup,
    CommentsChange,
    ChangeDate,
    TodayClick,
    HoursChange,
    DiagnosisChange,
    AddDiagnosisToList,
    RemoveDiagnosisFromList,
    AddCodeToList,
    RemoveCodeToList,
    OnSrvClick,
    OnLessThan500HeaderClick,
    OnMoreThan500PatientClick,
    OnMoreThan1000PatientClick,
    OnMoreThan1500PatientClick,
    OnCheckboxClickRdv,
    OnCheckboxClickGrossesse,
    OnCheckboxVADomicileClick,
    OnCheckboxSrvNonInscritClick,
    OnCheckboxAutreClick,
    OnEvalReferreCheckboxClick,
    OnCheckboxCsstClick,
    OnCheckboxCommunicationClick,
    OnCheckboxFavoriteClick,
    OnCancelClick,
    OnContinueClick,
    Referrals_OnClear,
    Referrals_OnChange,
    Referrals_OnTextChange,
    SetDateGrossesse,
    TodayClickGrossesse,
    SetDateCsst,
    TodayClickCSST,
    RemoveRefDoctor,
    ChangeContextAutres,
    OnPsychoRadioClick,
    OnIntClinClick,
    CommSpec_OnClear,
    CommSpec_OnChange,
    CommSpec_OnTextChange,
    RemoveCommSpecDoctor,
    OnCommProfFirstNameChange,
    OnCommProfLastNameChange,
    OnCommProfTypeSelection,
    OnCommProfOutQuebecClick,
    OnCommProfQuebecClick,
    RemoveCommProfDoctor,
    OnPecRadioCheck,
    AddFavoriteClick,
    OnCancelFavoriteClick,
    OnSrvOrRdvCancelClick,
    OnAddNewFavoriteClick,
    OnMesure1TextChange,
    OnMesure2TextChange,
    OnFavoriteRemove,
    GenerateBill,
    DeleteBill,
    SceanceDiffClick,
    OpenExistingBill,
    PrepareNewBill,
    ConferenceCallClick,
    ConferenceTypeSet,
    CloseSpecialityPopup
}

enum GrowthCharts {
    SetPatientBornPrematureData = 6900,
    SetStartDateFilter,
    SetEndDateFilter,
    SetUnitFilter,
    LoadGrowthCurvesCache,
    ExportPatientCharts,
    SetSelectedCharts,
    PortalClick,
    PortalRevokedClicked,
    PortalStatusCancel,
    PortalSendClicked,
    LoadGrowthChartSharedItem,
    PortalGrowthChartMessageChecked
}

enum Flowsheets {
    AddFlowsheetSummary = 7000,
    DeleteFlowsheet,
    SaveFlowsheet,
    SetForceReload
}

export { Appointment, Fax, Flowsheets, Graphs, GrowthCharts, History, MedfarBilling, MedicalItems, MedicalNote, MedicalSummary, MedicationGrid, MedicationTab, PrescriptionTab, Profile, UI };
